import * as React from 'react';
import { useAuthProvider } from '../core/context/ProvidersContext';
import styles from './LoginPage.module.scss';

export interface ILoginPageProps {
  onLoginSuccess: () => void;
}

export const LoginPage: React.FC<ILoginPageProps> = ({ onLoginSuccess }) => {
  const auth = useAuthProvider();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    if (!auth.login) return;
    setLoading(true);
    setError(null);
    try {
      await auth.login(email, password);
      onLoginSuccess();
    } catch (err) {
      setError((err as Error).message || 'Échec de la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.logo}>RM</div>
          <h1 className={styles.title}>Gestion des Bacs</h1>
          <p className={styles.subtitle}>Raffinerie du Midi</p>
        </div>
        <form className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.label}>
            Email
            <input
              type="email"
              className={styles.input}
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </label>
          <label className={styles.label}>
            Mot de passe
            <input
              type="password"
              className={styles.input}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </label>
          {error && <div className={styles.error}>{error}</div>}
          <button type="submit" className={styles.button} disabled={loading}>
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};
